export default {"src":"/_next/static/media/love-white.38b6d719.svg","height":44,"width":43,"blurWidth":0,"blurHeight":0};